import React, {useEffect, useState, useRef} from 'react';
import {evaluate} from '@mdx-js/mdx';
import * as runtime from 'react/jsx-runtime';
import remarkGfm from 'remark-gfm';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';

import EditorEmbed from './code/EditorEmbed';
import {MDXSyntaxHighlighter, Pre, CodeSwitcher} from './SyntaxHighlighter';

import {
  H1,
  H2,
  A,
  Table,
  THead,
  TBody,
  TH,
  TD,
  LI,
} from './Markdown';
import CalloutBox from './Callout';
import QuestionWidget from './QuestionWidget';

export default function MDX({
  className,
  children,
  placeholder = null,
  onRender = null,
}) {
  const mdx = children;
  const [componentLoaded, setComponentLoaded] = useState(false);
  const componentRef = useRef(undefined);

  useEffect(() => {
    async function getMDX() {
      const c = (await evaluate(mdx, {
        ...runtime,
        rehypePlugins: [rehypeKatex],
        remarkPlugins: [remarkGfm, [remarkMath, {singleDollarTextMath: false}]],
      })).default;
      componentRef.current = c;
      setComponentLoaded(true);
    }
    getMDX();
  }, []);

  useEffect(() => {
    if (componentLoaded) onRender?.();
  }, [componentLoaded]);

  if (!componentLoaded) return placeholder;

  const Component = componentRef.current;

  return (
    <div className={className}>
      <Component
        components={{
          a: A,
          CalloutBox,
          code: MDXSyntaxHighlighter,
          CodeSwitcher,
          h1: H1,
          h2: H2,
          pre: Pre,
          QuestionWidget,
          SQLEditor: EditorEmbed,
          table: Table,
          tbody: TBody,
          thead: THead,
          th: TH,
          td: TD,
          li: LI,
        }}
      />
    </div>
  );
}
